var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('v-row',_vm._l((_vm.items),function(i,index){return _c('v-col',{key:("innere-" + index),attrs:{"cols":"6"}},[_c('travel-site',{attrs:{"item":i}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }